import { connect } from 'react-redux';
import UserRole from './UserRole';
import {
  getUsersOnRole,
  getRolesList,
  createRole,
  createRoleClear,
  updateRole,
  updateRoleClear,
  getPermissionsOnRole,
  getPermissions,
  getPermissionValues,
  addPermissionOnRole,
  addPermissionOnRoleClear,
  deletePermissionOnRole,
  deletePermissionOnRoleClear
} from '../../../store/actions/admin';

const mapStateToProps = ({ adminReducer }) => ({ adminReducer });
const mapDispatchToProps = {
  getUsersOnRole,
  getRolesList,
  createRole,
  createRoleClear,
  updateRole,
  updateRoleClear,
  getPermissionsOnRole,
  getPermissions,
  getPermissionValues,
  addPermissionOnRole,
  addPermissionOnRoleClear,
  deletePermissionOnRole,
  deletePermissionOnRoleClear
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRole);
